import React, { useEffect, useMemo, useState } from 'react';

import * as S from './styles';
import {
  KenloSignatureTextIcon,
  MailCircleSignature,
  PersonCircle,
  Gift,
} from 'components/Icons';

import { Banner } from 'components/Banner';

import { Close } from 'styled-icons/ionicons-outline';
import { Line } from 'components/Line';
import NumberInputComponent from '../components/NumberInputComponent';
import { ArrowSync } from 'styled-icons/fluentui-system-regular';
import { InvoiceStatus } from 'components/InvoiceStatus';
import { Warning } from 'styled-icons/fluentui-system-filled';
import WarningTriangle from 'components/Icons/WarningTriangle';
import { ToolTip } from 'components/ToolTip';
import { api } from 'services/api';
import { customRoundCurrency } from 'pages/KenloSignature';
import { Modal } from 'components/Modal/Modal';
interface IAlter {
  closeDrawer: () => void;
  valueCurrentPlan:number
  dateCurrentPlan:string
  currentBalance:number
  currentTotalBalance:number
}
const observation = [
  {
    icon: <Warning size={24} color="#298EE6" />,
    text: (
      <S.Subtitle>
        Você receberá os
        <S.SubtitleBold>
          {' '}
          envelopes adicionais do novo plano de forma proporcional aos dias
          restantes{' '}
        </S.SubtitleBold>
        e podem ser usados sempre até a renovação.
      </S.Subtitle>
    ),
  },

  {
    icon: <ArrowSync size={24} color="#298EE6" />,
    text: (
      <S.Subtitle>
        <S.SubtitleBold>
          {' '}
          O plano continua sendo renovado mensalmente
        </S.SubtitleBold>
        e pode ser cancelado a qualquer momento.
      </S.Subtitle>
    ),
  },
  {
    icon: <PersonCircle />,
    text: (
      <S.Subtitle>
        Acesse os boletos e visualize o histórico dos créditos através da
        <S.SubtitleBold>&nbsp;área do cliente.</S.SubtitleBold>
      </S.Subtitle>
    ),
  },
];

const Alter = ({ closeDrawer, valueCurrentPlan, dateCurrentPlan,currentBalance,currentTotalBalance }: IAlter) => {
  const [quantity, setQuantity] = useState(currentTotalBalance);
  const [productPrice,setProductPrice] = useState<any>({});
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [products,setProducts] = useState<any[]>([]);
  const Contract = async () => {
    const accessToken = localStorage.getItem('accessToken');
    const idToken = localStorage.getItem('idToken');
    const idProduct  = products[0].id_product
    try {
     await api.post(
        `case`,
        {
          useNegative: true,
          frequency: "mensal",
          type: "upgrade",
          products: [
            {
            id_product: idProduct,
            quantity: quantity
            }
          ],
          log: {
            id_log_type: 1,
            title: 'Solicitou a contratação do Kenlo Assinaturas',
            description: `${quantity} envelopes no valor de ${
              customRoundCurrency((productPrice.cost * quantity) - (productPrice.cost * quantity * discount/100))
            } por mês.`
          },
        },
        {
          headers: {
            'content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        },
      );
      closeDrawer();
    } catch (error) {
      setIsOpenModal(true);
    }
  };
  useEffect(() => {
    const fetchDataProducts = async () => {
      const accessToken = localStorage.getItem('accessToken');
      const idToken = localStorage.getItem('idToken');
      try {
        const { data } = await api.get(
          `external-products/7`,
          {
            headers: {
              'content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
              idToken,
            },
          },
        );
        setProducts(data.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchDataProducts();
  }, []);
  useEffect(() => {
    const fetchDataPrices = async () => {
      const accessToken = localStorage.getItem('accessToken');
      const idToken = localStorage.getItem('idToken');
      try {
        const idProduct  = products[0].id_product
        const { data } = await api.get(
          `external-products/prices/?id_product=${idProduct}&frequency=mensal`,
          {
            headers: {
              'content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
              idToken,
            },
          },
        );
        setProductPrice(data.data);
      } catch (error) {
        console.log(error);
      }
    };
    
    products[0] && fetchDataPrices();
  }, [products]);
  const discount = useMemo(()=>{
    const discounts = productPrice?.discounts;
    if (!Array.isArray(discounts) || discounts.length === 0) return 0;
  
    const applicable = discounts
      .filter((d: any) => typeof d?.min_quantity === 'number' && typeof d?.perc_discount === 'number' && quantity >= d.min_quantity)
      .sort((a: any, b: any) => b.min_quantity - a.min_quantity);
  
    if (applicable.length === 0) return 0;
    return applicable[0].perc_discount;
  },[productPrice?.discounts, quantity])
  const percentage = useMemo(() => {
    const amount = currentTotalBalance

    if (currentBalance === 0 || amount === 0) {
      return '0';
    }
    return (((currentBalance as number) / amount) * 100)
      .toFixed(2)
      .toString();
  }, [
    currentBalance,
    currentTotalBalance,
  ]);
  return (
    <>
      <S.Header>
        <S.Infos>
          <S.Profile>
            <KenloSignatureTextIcon />
          </S.Profile>

          <S.Close onClick={closeDrawer}>
            <Close size={24} />
          </S.Close>
        </S.Infos>

        <S.Infos>
          <S.Subtitle>
            Personalize seu novo plano e confira os valores e condições.
          </S.Subtitle>
        </S.Infos>
      </S.Header>
      <S.Main>
        <S.Box>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',

              justifyContent: 'space-between',
            }}
          >
            <S.TextAside
              fontSize="20"
              fontWeight="700"
              style={{ marginBottom: '16px' }}
            >
              Plano atual
            </S.TextAside>
            <InvoiceStatus status="venda" text={'Mensal'} fontWeight="500" />
          </div>

          <S.Grid>
            <div>
              <S.TextAside fontSize="12" color="#808080">
                Valor
              </S.TextAside>
              <S.TextAside>{customRoundCurrency(valueCurrentPlan)}</S.TextAside>
            </div>
            <div>
              <S.TextAside fontSize="12" color="#808080">
                renovação
              </S.TextAside>
              <S.TextAside>{dateCurrentPlan}</S.TextAside>
            </div>
          </S.Grid>
          <S.TextAside fontSize="12" color="#808080">
            Saldo disponível
          </S.TextAside>
          <S.TextAside style={{ display: 'flex', gap: '8px' }}>
            {currentBalance}
            <S.TextAside fontSize="12" color="#808080">
              /{currentTotalBalance}
            </S.TextAside>
          </S.TextAside>
          <S.ProgressBar percentage={percentage} />
        </S.Box>

        <S.Box>
          <S.BoxContent>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',

                justifyContent: 'space-between',
              }}
            >
              <S.TextAside
                fontSize="20"
                fontWeight="700"
                style={{ marginBottom: '16px' }}
              >
                Novo plano
              </S.TextAside>
              <ToolTip
                right="2rem"
                height="3rem"
                content="Entre em contato conosco pelo chat para solicitar alteração da frequência de pagamento do plano."
                icon={
                  <InvoiceStatus
                    status="venda"
                    text={'Mensal'}
                    fontWeight="500"
                  />
                }
              />
            </div>
            <S.Form>
              <S.Subtitle>
                <MailCircleSignature />
                <S.SubtitleBold>&nbsp;&nbsp;Envelopes</S.SubtitleBold>
              </S.Subtitle>
              <NumberInputComponent
                value={quantity}
                onChange={(newValue) => {
                  setQuantity(newValue);
                }}
                min={1}
                max={20000}
              />
            </S.Form>
            <Line width="100%" border="0.1rem" />

            <S.BoxFooter>
              {discount  === 0 ? <div></div> 
              : <InvoiceStatus
                status={'kenloSignatureGift'}
                text={`${discount}% de desconto`}
                icon={<Gift color="white" />}
                fontWeight="500"
                colortText="white"
              />}
             
              <S.ContentFooter>
                <S.TitleValue>Pagamento no boleto</S.TitleValue>
                <S.Value>{customRoundCurrency(productPrice?.cost ? (productPrice.cost * quantity) - (productPrice.cost * quantity * discount/100) : 0)}</S.Value>
              </S.ContentFooter>
            </S.BoxFooter>
          </S.BoxContent>
        </S.Box>
        {quantity <= currentTotalBalance ? (
          <S.Box>
            <S.BoxContent>
              <S.SubtitleBold>Observações</S.SubtitleBold>
              {observation.map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    gap: '16px',
                    alignItems: 'center',
                    marginTop: '16px',
                  }}
                >
                  <div>{item.icon}</div>
                  <div>{item.text}</div>
                </div>
              ))}
            </S.BoxContent>
          </S.Box>
        ) : (
          <Banner
            icon={<WarningTriangle />}
            text="Entre em contato conosco para escolher um plano com menos envelopes ou interromper a assinatura."
          />
        )}
      </S.Main>
      <S.DrawerFooter>
        <S.CustomButton variant="link"> Cancelar</S.CustomButton>
        <S.CustomButton variant="primary" onClick={()=>quantity<=currentTotalBalance ? Contract() : null}>
          {quantity <= currentTotalBalance ? 'Alterar plano' : 'Falar com consultor'}
        </S.CustomButton>
      </S.DrawerFooter>
      {isOpenModal && (
        <Modal
          isOpen={isOpenModal}
          onClose={() => setIsOpenModal(false)}
          title="Não é possível alterar agora"
          closeText="Abrir chat"
          successText="Fechar"
          onSuccess={() => {
            setIsOpenModal(false);
          }}
        >
          <S.TextInfos lineWeight="500">
            Já existe uma solicitação de alteração desse produto em andamento.
            Aguarde a finalização ou fale com nosso time se a solicitação
            estiver demorando mais do que o esperado.
          </S.TextInfos>
        </Modal>
      )}
    </>
  );
};
export default Alter;
